// ملف الترجمات لجميع اللغات

export const translations = {
  ar: {
    code: "ar",
    name: "العربية",
    dir: "rtl",
    flag: "🇸🇾",
    tagline: "أفران درة الشام",
    nav: {
      home: "الرئيسية",
      products: "منتجاتنا",
      about: "من نحن",
      contact: "تواصل معنا",
      login: "تسجيل الدخول",
      callUs: "اتصل بنا"
    },
    hero: {
      badge: "طازج يومياً منذ 2020",
      title: "أفران درة الشام",
      subtitle: "الخبز الأصيل",
      description: "تقاليد عريقة من بلاد الشام، جودة ألمانية، وطعم لا يُنسى",
      cta: "اكتشف منتجاتنا",
      tagline: "أصالة المخبوزات الشامية",
      browseProducts: "تصفح منتجاتنا",
      contactUs: "تواصل معنا"
    },
    features: {
      fresh: {
        title: "طازج يومياً",
        desc: "نخبز كل صباح قبل الفجر"
      },
      natural: {
        title: "مكونات طبيعية",
        desc: "بدون مواد حافظة أو مضافة"
      },
      traditional: {
        title: "وصفات أصيلة",
        desc: "موروثة عبر الأجيال"
      }
    },
    login: {
      welcome: "مرحباً بك",
      chooseMethod: "اختر طريقة تسجيل الدخول المفضلة لديك",
      backToHome: "العودة للرئيسية",
      emailLogin: "تسجيل الدخول بالإيميل",
      emailDesc: "قم بإنشاء حساب جديد أو تسجيل الدخول باستخدام البريد الإلكتروني وكلمة المرور",
      whatsappLogin: "تسجيل الدخول بالواتساب",
      whatsappDesc: "تسجيل دخول سريع وآمن باستخدام رقم الواتساب الخاص بك",
      startNow: "ابدأ الآن",
      haveAccount: "لديك حساب بالفعل؟ اختر طريقة الدخول المناسبة لمتابعة طلباتك وإدارة حسابك"
    },
    register: {
      title: "إنشاء حساب جديد",
      subtitle: "أدخل بياناتك لإنشاء حساب تجاري",
      fullName: "الاسم الكامل",
      fullNamePlaceholder: "أدخل اسمك الكامل",
      companyName: "اسم الشركة / المؤسسة",
      companyNamePlaceholder: "أدخل اسم شركتك",
      companyType: "نوع النشاط التجاري",
      selectCompanyType: "اختر نوع النشاط",
      restaurant: "مطعم",
      supermarket: "سوبرماركت",
      distributor: "موزع",
      merchant: "تاجر",
      other: "أخرى",
      phone: "رقم الهاتف",
      phonePlaceholder: "أدخل رقم هاتفك",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل بريدك الإلكتروني",
      password: "كلمة المرور",
      passwordPlaceholder: "أدخل كلمة المرور",
      confirmPassword: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
      createAccount: "إنشاء الحساب",
      haveAccountLogin: "لديك حساب؟",
      loginHere: "سجل دخول من هنا",
      backToOptions: "العودة لخيارات التسجيل"
    },
    products: {
      title: "منتجاتنا",
      subtitle: "أشهى أنواع الخبز العربي والمعجنات الشرقية محضرة بأيدي خبراء",
      comingSoon: "قريباً",
      notAvailable: "غير متوفر حالياً",
      items: {
        sajBread: { name: "خبز الصاج", desc: "خبز رقيق طازج على الصاج الحار" },
        tannourBread: { name: "خبز التنور", desc: "خبز عربي أصيل من التنور الحجري" },
        shamiPastries: { name: "معجنات شامية", desc: "فطائر وسمبوسك بحشوات متنوعة" },
        easternSweets: { name: "حلويات شرقية", desc: "بقلاوة ومعمول وكنافة طازجة" },
        croissantSamoon: { name: "الكروصان والصمون", desc: "كروصان طازج وصمون يومي" },
        turkishBread: { name: "الخبز التركي", desc: "خبز البيدا التركي والصمون التركي" }
      }
    },
    about: {
      title: "من نحن",
      subtitle: "رحلة عشق مع الخبز الشامي الأصيل منذ أكثر من عقدين",
      storyTitle: "قصتنا مع الخبز",
      storyText: "بدأت رحلتنا من قلب دمشق، حيث توارثنا فن صناعة الخبز جيلاً بعد جيل. اليوم، نفخر بتقديم نفس الطعم الأصيل في قلب ألمانيا، محافظين على الوصفات التقليدية مع لمسة من الإبداع.",
      features: {
        freshIngredients: { title: "مكونات طازجة", desc: "نستخدم أجود أنواع الطحين والمكونات الطازجة يومياً" },
        authenticRecipes: { title: "وصفات أصيلة", desc: "وصفات شامية متوارثة عبر الأجيال" },
        longExperience: { title: "خبرة طويلة", desc: "لأعوام في صناعة الخبز التقليدي" }
      }
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "يسعدنا زيارتكم أو التواصل معنا",
      address: "العنوان",
      phone: "الهاتف",
      email: "البريد",
      hours: "ساعات العمل",
      hoursValue: "يومياً من 12 صباحاً - 10 مساءً",
      location: "شتوتغارت، ألمانيا",
      getDirections: "الحصول على الاتجاهات"
    },
    footer: {
      quickLinks: "روابط سريعة",
      contactUs: "تواصل معنا",
      rights: "جميع الحقوق محفوظة",
      madeWith: "صنع بكل",
      inGermany: "في ألمانيا"
    }
  },
  en: {
    code: "en",
    name: "English",
    dir: "ltr",
    flag: "🇬🇧",
    tagline: "Dura Alsham Bakery",
    nav: {
      home: "Home",
      products: "Products",
      about: "About Us",
      contact: "Contact",
      login: "Login",
      callUs: "Call Us"
    },
    hero: {
      badge: "Fresh Daily Since 2020",
      title: "Dura Alsham Bakery",
      subtitle: "Authentic Bread",
      description: "Ancient traditions from the Levant, German quality, unforgettable taste",
      cta: "Discover Our Products",
      tagline: "Authentic Levantine Bread",
      browseProducts: "Browse Products",
      contactUs: "Contact Us"
    },
    features: {
      fresh: {
        title: "Fresh Daily",
        desc: "Baked every morning before dawn"
      },
      natural: {
        title: "Natural Ingredients",
        desc: "No preservatives or additives"
      },
      traditional: {
        title: "Authentic Recipes",
        desc: "Inherited through generations"
      }
    },
    login: {
      welcome: "Welcome",
      chooseMethod: "Choose your preferred login method",
      backToHome: "Back to Home",
      emailLogin: "Login with Email",
      emailDesc: "Create a new account or login using email and password",
      whatsappLogin: "Login with WhatsApp",
      whatsappDesc: "Quick and secure login using your WhatsApp number",
      startNow: "Start Now",
      haveAccount: "Already have an account? Choose the appropriate login method to track your orders"
    },
    register: {
      title: "Create New Account",
      subtitle: "Enter your details to create a business account",
      fullName: "Full Name",
      fullNamePlaceholder: "Enter your full name",
      companyName: "Company Name",
      companyNamePlaceholder: "Enter your company name",
      companyType: "Business Type",
      selectCompanyType: "Select business type",
      restaurant: "Restaurant",
      supermarket: "Supermarket",
      distributor: "Distributor",
      merchant: "Merchant",
      other: "Other",
      phone: "Phone Number",
      phonePlaceholder: "Enter your phone number",
      email: "Email",
      emailPlaceholder: "Enter your email",
      password: "Password",
      passwordPlaceholder: "Enter password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter password",
      createAccount: "Create Account",
      haveAccountLogin: "Have an account?",
      loginHere: "Login here",
      backToOptions: "Back to login options"
    },
    products: {
      title: "Our Products",
      subtitle: "The finest Arabic bread and oriental pastries prepared by experts",
      comingSoon: "Coming Soon",
      notAvailable: "Not Available Yet",
      items: {
        sajBread: { name: "Saj Bread", desc: "Fresh thin bread on hot saj" },
        tannourBread: { name: "Tannour Bread", desc: "Authentic Arabic bread from stone oven" },
        shamiPastries: { name: "Shami Pastries", desc: "Pies and samosas with various fillings" },
        easternSweets: { name: "Eastern Sweets", desc: "Fresh baklava, maamoul and kunafa" },
        croissantSamoon: { name: "Croissant & Samoon", desc: "Fresh croissant and daily samoon" },
        turkishBread: { name: "Turkish Bread", desc: "Turkish pide and samoon bread" }
      }
    },
    about: {
      title: "About Us",
      subtitle: "A journey of passion with authentic Levantine bread for over two decades",
      storyTitle: "Our Story with Bread",
      storyText: "Our journey began from the heart of Damascus, where we inherited the art of bread making generation after generation. Today, we are proud to offer the same authentic taste in the heart of Germany, preserving traditional recipes with a touch of creativity.",
      features: {
        freshIngredients: { title: "Fresh Ingredients", desc: "We use the finest flour and fresh ingredients daily" },
        authenticRecipes: { title: "Authentic Recipes", desc: "Levantine recipes passed down through generations" },
        longExperience: { title: "Long Experience", desc: "Years in traditional bread making" }
      }
    },
    contact: {
      title: "Contact Us",
      subtitle: "We are happy to receive your visit or contact",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Working Hours",
      hoursValue: "Daily from 12 AM - 10 PM",
      location: "Stuttgart, Germany",
      getDirections: "Get Directions"
    },
    footer: {
      quickLinks: "Quick Links",
      contactUs: "Contact Us",
      rights: "All rights reserved",
      madeWith: "Made with",
      inGermany: "in Germany"
    }
  },
  de: {
    code: "de",
    name: "Deutsch",
    dir: "ltr",
    nav: {
      home: "Startseite",
      products: "Produkte",
      about: "Über uns",
      contact: "Kontakt",
      login: "Anmelden",
      callUs: "Anrufen"
    },
    hero: {
      badge: "Täglich frisch seit 2020",
      title: "Dura Alsham Bäckerei",
      subtitle: "Authentisches Brot",
      description: "Alte Traditionen aus der Levante, deutsche Qualität, unvergesslicher Geschmack",
      cta: "Entdecken Sie unsere Produkte",
      tagline: "Authentisches levantinisches Brot",
      browseProducts: "Produkte ansehen",
      contactUs: "Kontakt"
    },
    features: {
      fresh: {
        title: "Täglich frisch",
        desc: "Jeden Morgen vor Sonnenaufgang gebacken"
      },
      natural: {
        title: "Natürliche Zutaten",
        desc: "Ohne Konservierungsmittel oder Zusatzstoffe"
      },
      traditional: {
        title: "Authentische Rezepte",
        desc: "Über Generationen weitergegeben"
      }
    },
    login: {
      welcome: "Willkommen",
      chooseMethod: "Wählen Sie Ihre bevorzugte Anmeldemethode",
      backToHome: "Zurück zur Startseite",
      emailLogin: "Mit E-Mail anmelden",
      emailDesc: "Erstellen Sie ein neues Konto oder melden Sie sich mit E-Mail und Passwort an",
      whatsappLogin: "Mit WhatsApp anmelden",
      whatsappDesc: "Schnelle und sichere Anmeldung mit Ihrer WhatsApp-Nummer",
      startNow: "Jetzt starten",
      haveAccount: "Sie haben bereits ein Konto? Wählen Sie die passende Anmeldemethode"
    },
    register: {
      title: "Neues Konto erstellen",
      subtitle: "Geben Sie Ihre Daten ein, um ein Geschäftskonto zu erstellen",
      fullName: "Vollständiger Name",
      fullNamePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
      companyName: "Firmenname",
      companyNamePlaceholder: "Geben Sie Ihren Firmennamen ein",
      companyType: "Geschäftstyp",
      selectCompanyType: "Geschäftstyp auswählen",
      restaurant: "Restaurant",
      supermarket: "Supermarkt",
      distributor: "Händler",
      merchant: "Kaufmann",
      other: "Andere",
      phone: "Telefonnummer",
      phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
      email: "E-Mail",
      emailPlaceholder: "Geben Sie Ihre E-Mail ein",
      password: "Passwort",
      passwordPlaceholder: "Passwort eingeben",
      confirmPassword: "Passwort bestätigen",
      confirmPasswordPlaceholder: "Passwort erneut eingeben",
      createAccount: "Konto erstellen",
      haveAccountLogin: "Haben Sie ein Konto?",
      loginHere: "Hier anmelden",
      backToOptions: "Zurück zu den Anmeldeoptionen"
    },
    products: {
      title: "Unsere Produkte",
      subtitle: "Die feinsten arabischen Brote und orientalischen Backwaren von Experten zubereitet",
      comingSoon: "Demnächst",
      notAvailable: "Noch nicht verfügbar",
      items: {
        sajBread: { name: "Saj-Brot", desc: "Frisches dünnes Brot auf heißem Saj" },
        tannourBread: { name: "Tannour-Brot", desc: "Authentisches arabisches Brot aus dem Steinofen" },
        shamiPastries: { name: "Shami-Gebäck", desc: "Teigtaschen und Samosas mit verschiedenen Füllungen" },
        easternSweets: { name: "Orientalische Süßigkeiten", desc: "Frisches Baklava, Maamoul und Kunafa" },
        croissantSamoon: { name: "Croissant & Samoon", desc: "Frisches Croissant und tägliches Samoon" },
        turkishBread: { name: "Türkisches Brot", desc: "Türkisches Pide und Samoon-Brot" }
      }
    },
    about: {
      title: "Über uns",
      subtitle: "Eine Reise der Leidenschaft mit authentischem levantinischem Brot seit über zwei Jahrzehnten",
      storyTitle: "Unsere Geschichte mit Brot",
      storyText: "Unsere Reise begann im Herzen von Damaskus, wo wir die Kunst des Brotbackens von Generation zu Generation geerbt haben. Heute sind wir stolz darauf, denselben authentischen Geschmack im Herzen Deutschlands anzubieten und dabei traditionelle Rezepte mit einem Hauch von Kreativität zu bewahren.",
      features: {
        freshIngredients: { title: "Frische Zutaten", desc: "Wir verwenden täglich das feinste Mehl und frische Zutaten" },
        authenticRecipes: { title: "Authentische Rezepte", desc: "Levantinische Rezepte über Generationen weitergegeben" },
        longExperience: { title: "Lange Erfahrung", desc: "Jahre in der traditionellen Brotbäckerei" }
      }
    },
    contact: {
      title: "Kontakt",
      subtitle: "Wir freuen uns über Ihren Besuch oder Ihre Kontaktaufnahme",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      hours: "Öffnungszeiten",
      hoursValue: "Täglich von 12 bis 22 Uhr",
      location: "Stuttgart, Deutschland",
      getDirections: "Route berechnen"
    },
    footer: {
      quickLinks: "Schnelllinks",
      contactUs: "Kontakt",
      rights: "Alle Rechte vorbehalten",
      madeWith: "Hergestellt mit",
      inGermany: "in Deutschland"
    }
  },
  fr: {
    code: "fr",
    name: "Français",
    dir: "ltr",
    nav: {
      home: "Accueil",
      products: "Produits",
      about: "À propos",
      contact: "Contact",
      login: "Connexion",
      callUs: "Appelez-nous"
    },
    hero: {
      badge: "Frais tous les jours depuis 2020",
      title: "Boulangerie Dura Alsham",
      subtitle: "Pain Authentique",
      description: "Traditions anciennes du Levant, qualité allemande, goût inoubliable",
      cta: "Découvrir nos produits",
      tagline: "Pain levantin authentique",
      browseProducts: "Voir les produits",
      contactUs: "Contactez-nous"
    },
    features: {
      fresh: {
        title: "Frais tous les jours",
        desc: "Cuit chaque matin avant l'aube"
      },
      natural: {
        title: "Ingrédients naturels",
        desc: "Sans conservateurs ni additifs"
      },
      traditional: {
        title: "Recettes authentiques",
        desc: "Héritées de génération en génération"
      }
    },
    login: {
      welcome: "Bienvenue",
      chooseMethod: "Choisissez votre méthode de connexion préférée",
      backToHome: "Retour à l'accueil",
      emailLogin: "Connexion par e-mail",
      emailDesc: "Créez un nouveau compte ou connectez-vous avec e-mail et mot de passe",
      whatsappLogin: "Connexion par WhatsApp",
      whatsappDesc: "Connexion rapide et sécurisée avec votre numéro WhatsApp",
      startNow: "Commencer",
      haveAccount: "Vous avez déjà un compte? Choisissez la méthode de connexion appropriée"
    },
    register: {
      title: "Créer un nouveau compte",
      subtitle: "Entrez vos informations pour créer un compte professionnel",
      fullName: "Nom complet",
      fullNamePlaceholder: "Entrez votre nom complet",
      companyName: "Nom de l'entreprise",
      companyNamePlaceholder: "Entrez le nom de votre entreprise",
      companyType: "Type d'activité",
      selectCompanyType: "Sélectionnez le type d'activité",
      restaurant: "Restaurant",
      supermarket: "Supermarché",
      distributor: "Distributeur",
      merchant: "Commerçant",
      other: "Autre",
      phone: "Numéro de téléphone",
      phonePlaceholder: "Entrez votre numéro de téléphone",
      email: "E-mail",
      emailPlaceholder: "Entrez votre e-mail",
      password: "Mot de passe",
      passwordPlaceholder: "Entrez le mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      confirmPasswordPlaceholder: "Entrez à nouveau le mot de passe",
      createAccount: "Créer le compte",
      haveAccountLogin: "Vous avez un compte?",
      loginHere: "Connectez-vous ici",
      backToOptions: "Retour aux options de connexion"
    },
    products: {
      title: "Nos Produits",
      subtitle: "Les meilleurs pains arabes et pâtisseries orientales préparés par des experts",
      comingSoon: "Bientôt",
      notAvailable: "Pas encore disponible",
      items: {
        sajBread: { name: "Pain Saj", desc: "Pain fin frais sur saj chaud" },
        tannourBread: { name: "Pain Tannour", desc: "Pain arabe authentique du four en pierre" },
        shamiPastries: { name: "Pâtisseries Shami", desc: "Tartes et samosas avec diverses garnitures" },
        easternSweets: { name: "Douceurs orientales", desc: "Baklava, maamoul et kunafa frais" },
        croissantSamoon: { name: "Croissant & Samoon", desc: "Croissant frais et samoon quotidien" },
        turkishBread: { name: "Pain turc", desc: "Pide turc et pain samoon" }
      }
    },
    about: {
      title: "À propos",
      subtitle: "Un voyage passionné avec le pain levantin authentique depuis plus de deux décennies",
      storyTitle: "Notre histoire avec le pain",
      storyText: "Notre voyage a commencé au cœur de Damas, où nous avons hérité de l'art de la boulangerie de génération en génération. Aujourd'hui, nous sommes fiers d'offrir le même goût authentique au cœur de l'Allemagne, en préservant les recettes traditionnelles avec une touche de créativité.",
      features: {
        freshIngredients: { title: "Ingrédients frais", desc: "Nous utilisons quotidiennement la meilleure farine et des ingrédients frais" },
        authenticRecipes: { title: "Recettes authentiques", desc: "Recettes levantines transmises de génération en génération" },
        longExperience: { title: "Longue expérience", desc: "Des années dans la boulangerie traditionnelle" }
      }
    },
    contact: {
      title: "Contact",
      subtitle: "Nous sommes heureux de vous recevoir ou de vous contacter",
      address: "Adresse",
      phone: "Téléphone",
      email: "E-mail",
      hours: "Heures d'ouverture",
      hoursValue: "Tous les jours de 12h à 22h",
      location: "Stuttgart, Allemagne",
      getDirections: "Obtenir l'itinéraire"
    },
    footer: {
      quickLinks: "Liens rapides",
      contactUs: "Contact",
      rights: "Tous droits réservés",
      madeWith: "Fait avec",
      inGermany: "en Allemagne"
    }
  },
  tr: {
    code: "tr",
    name: "Türkçe",
    dir: "ltr",
    nav: {
      home: "Ana Sayfa",
      products: "Ürünler",
      about: "Hakkımızda",
      contact: "İletişim",
      login: "Giriş Yap",
      callUs: "Bizi Arayın"
    },
    hero: {
      badge: "2020'den beri her gün taze",
      title: "Dura Alsham Fırını",
      subtitle: "Otantik Ekmek",
      description: "Levant'tan kadim gelenekler, Alman kalitesi, unutulmaz lezzet",
      cta: "Ürünlerimizi keşfedin",
      tagline: "Otantik Levanten Ekmeği",
      browseProducts: "Ürünlere Göz At",
      contactUs: "İletişime Geç"
    },
    features: {
      fresh: {
        title: "Her gün taze",
        desc: "Her sabah şafaktan önce pişirilir"
      },
      natural: {
        title: "Doğal malzemeler",
        desc: "Koruyucu veya katkı maddesi yok"
      },
      traditional: {
        title: "Otantik tarifler",
        desc: "Nesilden nesile aktarılan"
      }
    },
    login: {
      welcome: "Hoş Geldiniz",
      chooseMethod: "Tercih ettiğiniz giriş yöntemini seçin",
      backToHome: "Ana Sayfaya Dön",
      emailLogin: "E-posta ile Giriş",
      emailDesc: "Yeni bir hesap oluşturun veya e-posta ve şifre ile giriş yapın",
      whatsappLogin: "WhatsApp ile Giriş",
      whatsappDesc: "WhatsApp numaranızla hızlı ve güvenli giriş",
      startNow: "Şimdi Başla",
      haveAccount: "Zaten hesabınız var mı? Uygun giriş yöntemini seçin"
    },
    register: {
      title: "Yeni Hesap Oluştur",
      subtitle: "İş hesabı oluşturmak için bilgilerinizi girin",
      fullName: "Tam Ad",
      fullNamePlaceholder: "Tam adınızı girin",
      companyName: "Şirket Adı",
      companyNamePlaceholder: "Şirket adınızı girin",
      companyType: "İş Türü",
      selectCompanyType: "İş türünü seçin",
      restaurant: "Restoran",
      supermarket: "Süpermarket",
      distributor: "Dağıtıcı",
      merchant: "Tüccar",
      other: "Diğer",
      phone: "Telefon Numarası",
      phonePlaceholder: "Telefon numaranızı girin",
      email: "E-posta",
      emailPlaceholder: "E-postanızı girin",
      password: "Şifre",
      passwordPlaceholder: "Şifre girin",
      confirmPassword: "Şifreyi Onayla",
      confirmPasswordPlaceholder: "Şifreyi tekrar girin",
      createAccount: "Hesap Oluştur",
      haveAccountLogin: "Hesabınız var mı?",
      loginHere: "Buradan giriş yapın",
      backToOptions: "Giriş seçeneklerine dön"
    },
    products: {
      title: "Ürünlerimiz",
      subtitle: "Uzmanlar tarafından hazırlanan en iyi Arap ekmekleri ve doğu tatlıları",
      comingSoon: "Yakında",
      notAvailable: "Henüz mevcut değil",
      items: {
        sajBread: { name: "Sac Ekmeği", desc: "Sıcak sacda taze ince ekmek" },
        tannourBread: { name: "Tandır Ekmeği", desc: "Taş fırından otantik Arap ekmeği" },
        shamiPastries: { name: "Şam Börekleri", desc: "Çeşitli dolgulu börekler ve samosalar" },
        easternSweets: { name: "Doğu Tatlıları", desc: "Taze baklava, maamul ve künefe" },
        croissantSamoon: { name: "Kruvasan & Samun", desc: "Taze kruvasan ve günlük samun" },
        turkishBread: { name: "Türk Ekmeği", desc: "Türk pidesi ve samun ekmeği" }
      }
    },
    about: {
      title: "Hakkımızda",
      subtitle: "Yirmi yılı aşkın bir süredir otantik Levanten ekmeğiyle tutkulu bir yolculuk",
      storyTitle: "Ekmekle Hikayemiz",
      storyText: "Yolculuğumuz Şam'ın kalbinden başladı, burada ekmek yapma sanatını nesilden nesile miras aldık. Bugün, geleneksel tarifleri bir dokunuş yaratıcılıkla koruyarak Almanya'nın kalbinde aynı otantik tadı sunmaktan gurur duyuyoruz.",
      features: {
        freshIngredients: { title: "Taze Malzemeler", desc: "Her gün en iyi un ve taze malzemeleri kullanıyoruz" },
        authenticRecipes: { title: "Otantik Tarifler", desc: "Nesilden nesile aktarılan Levanten tarifleri" },
        longExperience: { title: "Uzun Deneyim", desc: "Geleneksel ekmekçilikte yıllar" }
      }
    },
    contact: {
      title: "İletişim",
      subtitle: "Ziyaretinizi veya iletişiminizi memnuniyetle karşılıyoruz",
      address: "Adres",
      phone: "Telefon",
      email: "E-posta",
      hours: "Çalışma Saatleri",
      hoursValue: "Her gün 12:00 - 22:00",
      location: "Stuttgart, Almanya",
      getDirections: "Yol tarifi al"
    },
    footer: {
      quickLinks: "Hızlı Bağlantılar",
      contactUs: "İletişim",
      rights: "Tüm hakları saklıdır",
      madeWith: "ile yapıldı",
      inGermany: "Almanya'da"
    }
  },
  uk: {
    code: "uk",
    name: "Українська",
    dir: "ltr",
    nav: {
      home: "Головна",
      products: "Продукти",
      about: "Про нас",
      contact: "Контакти",
      login: "Увійти",
      callUs: "Зателефонуйте"
    },
    hero: {
      badge: "Щодня свіже з 2020",
      title: "Пекарня Dura Alsham",
      subtitle: "Автентичний хліб",
      description: "Стародавні традиції Леванту, німецька якість, незабутній смак",
      cta: "Відкрийте наші продукти",
      tagline: "Автентичний левантійський хліб",
      browseProducts: "Переглянути продукти",
      contactUs: "Зв'язатися з нами"
    },
    features: {
      fresh: {
        title: "Щодня свіже",
        desc: "Випікаємо кожного ранку до світанку"
      },
      natural: {
        title: "Натуральні інгредієнти",
        desc: "Без консервантів та добавок"
      },
      traditional: {
        title: "Автентичні рецепти",
        desc: "Передані через покоління"
      }
    },
    login: {
      welcome: "Ласкаво просимо",
      chooseMethod: "Виберіть бажаний спосіб входу",
      backToHome: "Повернутися на головну",
      emailLogin: "Вхід через e-mail",
      emailDesc: "Створіть новий обліковий запис або увійдіть за допомогою e-mail та пароля",
      whatsappLogin: "Вхід через WhatsApp",
      whatsappDesc: "Швидкий і безпечний вхід за номером WhatsApp",
      startNow: "Почати зараз",
      haveAccount: "Вже маєте обліковий запис? Виберіть відповідний спосіб входу"
    },
    register: {
      title: "Створити новий обліковий запис",
      subtitle: "Введіть свої дані для створення бізнес-облікового запису",
      fullName: "Повне ім'я",
      fullNamePlaceholder: "Введіть ваше повне ім'я",
      companyName: "Назва компанії",
      companyNamePlaceholder: "Введіть назву вашої компанії",
      companyType: "Тип бізнесу",
      selectCompanyType: "Виберіть тип бізнесу",
      restaurant: "Ресторан",
      supermarket: "Супермаркет",
      distributor: "Дистриб'ютор",
      merchant: "Торговець",
      other: "Інше",
      phone: "Номер телефону",
      phonePlaceholder: "Введіть номер телефону",
      email: "E-mail",
      emailPlaceholder: "Введіть ваш e-mail",
      password: "Пароль",
      passwordPlaceholder: "Введіть пароль",
      confirmPassword: "Підтвердіть пароль",
      confirmPasswordPlaceholder: "Введіть пароль ще раз",
      createAccount: "Створити обліковий запис",
      haveAccountLogin: "Маєте обліковий запис?",
      loginHere: "Увійдіть тут",
      backToOptions: "Повернутися до варіантів входу"
    },
    products: {
      title: "Наші продукти",
      subtitle: "Найкращий арабський хліб та східна випічка від експертів",
      comingSoon: "Незабаром",
      notAvailable: "Ще недоступно",
      items: {
        sajBread: { name: "Хліб Садж", desc: "Свіжий тонкий хліб на гарячому саджі" },
        tannourBread: { name: "Хліб Таннур", desc: "Автентичний арабський хліб з кам'яної печі" },
        shamiPastries: { name: "Шамі випічка", desc: "Пироги та самоси з різними начинками" },
        easternSweets: { name: "Східні солодощі", desc: "Свіжа пахлава, маамуль та кунафа" },
        croissantSamoon: { name: "Круасан і Самун", desc: "Свіжий круасан та щоденний самун" },
        turkishBread: { name: "Турецький хліб", desc: "Турецький піде та хліб самун" }
      }
    },
    about: {
      title: "Про нас",
      subtitle: "Подорож пристрасті з автентичним левантійським хлібом понад два десятиліття",
      storyTitle: "Наша історія з хлібом",
      storyText: "Наша подорож почалася з серця Дамаска, де ми успадкували мистецтво випікання хліба з покоління в покоління. Сьогодні ми пишаємося тим, що пропонуємо той самий автентичний смак у серці Німеччини, зберігаючи традиційні рецепти з дотиком творчості.",
      features: {
        freshIngredients: { title: "Свіжі інгредієнти", desc: "Ми щодня використовуємо найкраще борошно та свіжі інгредієнти" },
        authenticRecipes: { title: "Автентичні рецепти", desc: "Левантійські рецепти, передані через покоління" },
        longExperience: { title: "Великий досвід", desc: "Роки в традиційному хлібопеченні" }
      }
    },
    contact: {
      title: "Контакти",
      subtitle: "Ми раді вашому візиту або зверненню",
      address: "Адреса",
      phone: "Телефон",
      email: "Ел. пошта",
      hours: "Години роботи",
      hoursValue: "Щодня з 12:00 до 22:00",
      location: "Штутгарт, Німеччина",
      getDirections: "Прокласти маршрут"
    },
    footer: {
      quickLinks: "Швидкі посилання",
      contactUs: "Контакти",
      rights: "Усі права захищені",
      madeWith: "Зроблено з",
      inGermany: "у Німеччині"
    }
  },
  ku: {
    code: "ku",
    name: "Kurdî",
    dir: "ltr",
    nav: {
      home: "Destpêk",
      products: "Berhemên me",
      about: "Der barê me",
      contact: "Têkilî",
      login: "Têkeve",
      callUs: "Gazî me bikin"
    },
    hero: {
      badge: "Ji 2020 her roj teze",
      title: "Firina Dura Alsham",
      subtitle: "Nanê Rastîn",
      description: "Kevneşopiyên kevn ji Şamê, kalîteya Almanyayê, tamek bêhempa",
      cta: "Berhemên me bibînin",
      tagline: "Nanê Şamî yê rastîn",
      browseProducts: "Berheman bibînin",
      contactUs: "Bi me re têkilî daynin"
    },
    features: {
      fresh: {
        title: "Her roj teze",
        desc: "Her sibê beriya berbangê tê pijandin"
      },
      natural: {
        title: "Malzemeyên xwezayî",
        desc: "Bê parastox an lêzêdekar"
      },
      traditional: {
        title: "Reçeteyên rastîn",
        desc: "Ji nifşê ber bi nifşê"
      }
    },
    login: {
      welcome: "Bi xêr hatî",
      chooseMethod: "Awayê têketinê ya xwe hilbijêrin",
      backToHome: "Vegere serûpelê",
      emailLogin: "Bi e-nameyê têkeve",
      emailDesc: "Hesabek nû biafirînin an bi e-name û şîfreyê têkevin",
      whatsappLogin: "Bi WhatsApp-ê têkeve",
      whatsappDesc: "Têketinek bilez û ewle bi hejmara WhatsApp-ê",
      startNow: "Niha dest pê bike",
      haveAccount: "Hesabek te heye? Awayê têketinê ya guncaw hilbijêrin"
    },
    register: {
      title: "Hesabek nû biafirîne",
      subtitle: "Agahdariya xwe binivîse da ku hesabek bazirganî biafirînî",
      fullName: "Navê tevahî",
      fullNamePlaceholder: "Navê xwe yê tevahî binivîse",
      companyName: "Navê pargîdaniyê",
      companyNamePlaceholder: "Navê pargîdaniya xwe binivîse",
      companyType: "Cureya bazirganiyê",
      selectCompanyType: "Cureya bazirganiyê hilbijêrin",
      restaurant: "Xwaringeh",
      supermarket: "Sûpermarket",
      distributor: "Belavker",
      merchant: "Bazirgan",
      other: "Yên din",
      phone: "Hejmara têlefonê",
      phonePlaceholder: "Hejmara têlefonê binivîse",
      email: "E-name",
      emailPlaceholder: "E-nameya xwe binivîse",
      password: "Şîfre",
      passwordPlaceholder: "Şîfreyê binivîse",
      confirmPassword: "Şîfreyê piştrast bike",
      confirmPasswordPlaceholder: "Şîfreyê dîsa binivîse",
      createAccount: "Hesab biafirîne",
      haveAccountLogin: "Hesabek te heye?",
      loginHere: "Li vir têkeve",
      backToOptions: "Vegere vebijarkên têketinê"
    },
    products: {
      title: "Berhemên me",
      subtitle: "Çêtirîn nanê erebî û şîraniyên rojhilatî yên ji aliyê pisporan ve hatine amadekirin",
      comingSoon: "Di demek nêzîk de",
      notAvailable: "Hêj ne amade ye",
      items: {
        sajBread: { name: "Nanê Sacî", desc: "Nanê tenik ê teze li ser sacê germ" },
        tannourBread: { name: "Nanê Tendûr", desc: "Nanê erebî yê rastîn ji tendûra kevirîn" },
        shamiPastries: { name: "Şîraniyên Şamî", desc: "Börek û samosa bi tijiyên cûda" },
        easternSweets: { name: "Şîraniyên Rojhilatî", desc: "Baqlava, maamûl û künefe teze" },
        croissantSamoon: { name: "Kruvasan û Samûn", desc: "Kruvasan teze û samûn rojane" },
        turkishBread: { name: "Nanê Tirkî", desc: "Pîde û nanê samûnê tirkî" }
      }
    },
    about: {
      title: "Der barê me",
      subtitle: "Rêwîtiyek evîndar bi nanê Şamî yê rastîn ji zêdetirî du dehsalan",
      storyTitle: "Çîroka me bi nanî re",
      storyText: "Rêwîtiya me ji dilê Şamê dest pê kir, ku me hunera nanpêjiyê ji nifşê ber bi nifşê wergirt. Îro, em serbilind in ku heman tama rastîn li dilê Almanyayê pêşkêş bikin, bi parastina reçeteyên kevneşopî bi destekî afirîner.",
      features: {
        freshIngredients: { title: "Malzemeyên teze", desc: "Em her roj ard û malzemeyên çêtirîn û teze bi kar tînin" },
        authenticRecipes: { title: "Reçeteyên rastîn", desc: "Reçeteyên Şamî yên ji nifşê ber bi nifşê hatine veguheztin" },
        longExperience: { title: "Ezmûnek dirêj", desc: "Sal di nanpêjiya kevneşopî de" }
      }
    },
    contact: {
      title: "Têkilî",
      subtitle: "Em ji serdana an têkiliya we kêfxweş in",
      address: "Navnîşan",
      phone: "Têlefon",
      email: "E-peyam",
      hours: "Demjimêrên kar",
      hoursValue: "Her roj ji 12:00 heta 22:00",
      location: "Stuttgart, Almanya",
      getDirections: "Rêwîtiyê bistînin"
    },
    footer: {
      quickLinks: "Girêdanên bilez",
      contactUs: "Têkilî",
      rights: "Hemû maf parastî ne",
      madeWith: "Bi çêkirî",
      inGermany: "li Almanyayê"
    }
  }
};

export const languages = [
  { code: "ar", name: "العربية", flag: "🇸🇾", flagImage: "https://static.prod-images.emergentagent.com/jobs/6d406312-95a0-4894-8492-ee16582497a8/images/30eba6831c259c0c3236477893668bc441a4f5bad0a23bb2ebea86a9deadd329.jpeg" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
  { code: "uk", name: "Українська", flag: "🇺🇦" },
  { code: "ku", name: "Kurdî", flag: "🏳️" }
];
